import { Subject } from 'rxjs/Subject';
import { logoutAction } from "../../reducers/actions";
import { inactivityTimeoutDuration } from "../../constants/app";

const events = ['click', 'contextmenu', 'keypress', 'scroll', 'touchstart', 'wheel'];
var timerReference;
var logoutActionSubject;

const logout = () => {
  logoutActionSubject.next(logoutAction());
};

const clearTimer = () => {
  clearTimeout(timerReference);
};

const resetTimer = () => {
  clearTimer();
  timerReference = setTimeout(logout, inactivityTimeoutDuration);
};

const addInactivityListeners = () => {
  window.addEventListener('load', resetTimer, true);
  events.forEach((eventName) => {
    document.addEventListener(eventName, resetTimer, true); 
  });
};

const removeInactivityListeners = () => {
  window.removeEventListener('load', resetTimer, true);
  events.forEach((eventName) => {
    document.removeEventListener(eventName, resetTimer, true); 
  });
};

class InactivityService {
  /**
   * Starts timer to check inactivity
   * 
   * Returns an observable which would emit the logoutAction if inactivity period is reached
   *
   * @memberof InactivityService
   */
  start = () => {
    this.stop();
    resetTimer();
    addInactivityListeners();
    logoutActionSubject = new Subject();
    return logoutActionSubject.asObservable();
  }

  stop = () => {
    removeInactivityListeners();
    clearTimer();
    if (logoutActionSubject) {
      logoutActionSubject.complete();
    }
  }
}

export default new InactivityService();


// WEBPACK FOOTER //
// ./src/services/inactivity/index.js